// #ux-redesign-start: BtnReply usa Button DS y dispara `setReply(true)`
// para que InboxViewForm muestre el AsyncSelect de destinatarios.
import React from 'react';
import { useTranslate } from 'react-translate';
import { Button } from 'components/ds';

const BtnReply = ({ mobile, setShowForm, setReply, setResend, disabled }) => {
  const t = useTranslate('messages');
  return (
    <Button
      variant="primary"
      size={mobile ? 'sm' : 'md'}
      name="btn-menu-reply"
      onClick={() => {
        if (setResend) setResend(false);
        if (setReply) setReply(true);
        setShowForm(true);
      }}
      disabled={disabled}
      iconLeft={<i className="fas fa-reply" />}
    >
      {!mobile && t('btn-reply')}
    </Button>
  );
};

export default BtnReply;
// #ux-redesign-end
